import type { EnumUnion } from "@dresscode-frontend/utility-types";

/**
 * 取引先一覧のソート可能なカラム
 */
export const BusinessPartnerOrderBy = {
  BUSINESS_PARTNER_NAME: "BUSINESS_PARTNER_NAME",
  BUSINESS_PARTNER_TYPE: "BUSINESS_PARTNER_TYPE",
  BUSINESS_PARTNER_ACTIVE_PERIOD: "BUSINESS_PARTNER_ACTIVE_PERIOD",
  BUSINESS_PARTNER_REGISTRATION_DATE: "BUSINESS_PARTNER_REGISTRATION_DATE",
  BUSINESS_PARTNER_TERMINATION_DATE: "BUSINESS_PARTNER_TERMINATION_DATE",
} as const satisfies Record<string, string>;

export type BusinessPartnerOrderBy = EnumUnion<typeof BusinessPartnerOrderBy>;

/**
 * 取引先の役割
 */
export const BusinessPartnerRole = {
  CUSTOMER: "CUSTOMER",
  SUPPLIER: "SUPPLIER",
  FINANCIAL_INSTITUTION: "FINANCIAL_INSTITUTION",
  RESELLER_AGENT: "RESELLER_AGENT",
  EMPLOYEE: "EMPLOYEE",
} as const;

export type BusinessPartnerRole =
  (typeof BusinessPartnerRole)[keyof typeof BusinessPartnerRole];

/**
 * 取引先のタイプ
 */
export const BusinessPartnerType = {
  CORPORATION: "CORPORATION",
  INDIVIDUAL: "INDIVIDUAL",
  // TODO: GROUPの定義が確定してから対応
  // GROUP: "GROUP",
} as const;

export type BusinessPartnerType =
  (typeof BusinessPartnerType)[keyof typeof BusinessPartnerType];

export const BusinessPartnerTypeWithAll = {
  ...BusinessPartnerType,
  ALL: "ALL",
} as const;

export type BusinessPartnerTypeWithAll =
  (typeof BusinessPartnerTypeWithAll)[keyof typeof BusinessPartnerTypeWithAll];

/**
 * 取引先のステータス
 */
export const BusinessPartnerStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  PENDING_APPROVAL: "PENDING_APPROVAL",
  TERMINATED: "TERMINATED",
} as const;

export type BusinessPartnerStatus =
  (typeof BusinessPartnerStatus)[keyof typeof BusinessPartnerStatus];

/**
 * 法人のステータス
 */
export const CorporateStatus = {
  ACTIVE: "ACTIVE",
  DORMANT: "DORMANT",
  DISSOLVED: "DISSOLVED",
} as const;

export type CorporateStatus =
  (typeof CorporateStatus)[keyof typeof CorporateStatus];

/**
 * 法人のタイプ
 */
// TODO: 法人形態は仕様確定してから対応
// export const CorporateType = {
//   CORPORATION: "CORPORATION",
//   GENERAL_PARTNERSHIP: "GENERAL_PARTNERSHIP",
//   LIMITED_PARTNERSHIP: "LIMITED_PARTNERSHIP",
//   JOINT_VENTURE: "JOINT_VENTURE",
//   GENERAL_ASSOCIATION: "GENERAL_ASSOCIATION",
//   GENERAL_FOUNDATION: "GENERAL_FOUNDATION",
//   PUBLIC_ASSOCIATION: "PUBLIC_ASSOCIATION",
//   PUBLIC_FOUNDATION: "PUBLIC_FOUNDATION",
//   NPO: "NPO",
//   OTHER: "OTHER",
// } as const;

// export type CorporateType = (typeof CorporateType)[keyof typeof CorporateType];

/**
 * テーブルカラムの定義
 */
export const BusinessPartnerTableColumns = {
  businessPartnerName: "businessPartnerName",
  businessPartnerTypeLabel: "businessPartnerTypeLabel",
  businessPartnerRoles: "businessPartnerRoles",
  businessPartnerStatusLabel: "businessPartnerStatusLabel",
  businessPartnerActivePeriod: "businessPartnerActivePeriod",
  businessPartnerAddress: "businessPartnerAddress",
  businessPartnerRegistrationDate: "businessPartnerRegistrationDate",
  businessPartnerTerminationDate: "businessPartnerTerminationDate",
} as const;

export type BusinessPartnerTableColumns =
  (typeof BusinessPartnerTableColumns)[keyof typeof BusinessPartnerTableColumns];
